const u_GetCart = async () => {
  return await fetch("/cart.js").then(res => res.json());
}

const u_UpdateCart = (updates) => {
  if (!updates) {
    return;
  }
  return fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ updates })
  });
}

const u_AddToCart = (id, quantity = 1) => {
  if (!id || isNaN(quantity) || quantity <= 0) {
    console.error('Invalid parameters for u_AddToCart:', { id, quantity });
    return;
  }
  return fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },  
    body: JSON.stringify({ id, quantity })
  });
}

const u_ApplyDiscount = async(code) => {
  let data = { discount: code };

  return await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }).then(res => res.json());
}


const u_FetchCartSection = async () => {
  // Fetch the cart section with a timestamp to avoid caching issues
  // console.log('Fetching cart section...');  
  return await fetch(`/cart?section_id=shopify-section-${this.section_id}&t=${Date.now()}`).then(res => res.text());
}

const u_ConvertStringToHTML = (str) => {
  let parser = new DOMParser();
  let doc = parser.parseFromString(str, 'text/html');
  return doc.body;
}

const u_FormatMoney = (amount) => {
  return theme.Currency.formatMoney(amount);
}

document.addEventListener('alpine:init', () => {
  Alpine.store('cart', {
    cart: {
      item_count: 0,
      cart_level_discount_applications: [],
      items: [],
      discount_codes: []
    },
    async init() {
      // Load initial cart data
      this.UpdateCart();

      // when cart, update store cart
      document.addEventListener('cart:updated', this.UpdateCart.bind(this));
    },
    async UpdateCart() {
      this.cart = await u_GetCart();
      document.dispatchEvent(new CustomEvent('store:cart:updated'));
    }
  });

  Alpine.data('CartPage', () => ({
    cart: null,
    section_id: '',
    cache: {},
    flags: {
      cart_rendering: false,
      cart_empty: true, // used to show empty cart message
      add_prio_shipping: false, // used for the priority shipping upsell
      discount_error: false, // used to show discount error message
    },
    discount_code: '',
    discount_codes: [],
    shipping_product: null,
    item_prio_plus: null,
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitSelf() {
      this.cache.$cart = this.$el;
      this.cart = JSON.parse(this.cache.$cart.dataset.cart);
      this.shipping_product = JSON.parse(this.cache.$cart.dataset.shipping_product) || null;
      this.section_id = this.cache.$cart.dataset.section_id || '';

      // Remove the hidden attributes once loaded
      this.cache.$cart.querySelectorAll('[x-cloak-opacity]').forEach(el => {
        // console.log('Removing x-cloak-opacity from element:', el);
        el.removeAttribute('x-cloak-opacity');
      });
    },
    InitWatchers() {
      // render dynamic components
      this.$el.addEventListener('cart:updated', this.u_UpdateCartDynamicComponents.bind(this));
      this.$watch('cart', this.u_UpdateFlags.bind(this));
      this.$watch('cart', this.u_GetDiscountCodes.bind(this));
      this.$watch('cart', this.u_GetPrioItem.bind(this));

      // toggle priority shipping upsell
      this.$watch('flags.add_prio_shipping', this.u_PrioShippingToggle.bind(this));
    },

    async e_UpdateQuantity(e, qty) {
      let quantity, key;
      if (qty == 0) {
        quantity = 0;
        key = e.currentTarget.dataset.key;
      }
      else {
        let $qty_wrapper = e.target.closest('.js-qty__wrapper');
        let $input = $qty_wrapper.querySelector('.js-qty__num');
        quantity = parseInt($input.value, 10);
        key = $input.dataset.key;
      }
      if (isNaN(quantity) || quantity < 0) return;

      await u_UpdateCart({
        [key]: quantity
      })
      .catch(err => {
        console.error('Error updating cart:', err);
      });

      this.u_RenderCart({ quantity, key });
    },

    async e_ApplyDiscount(e) {
      let $btn = e.currentTarget;
      if (this.discount_code === '') return;
      $btn.classList.add('is-loading');
      let res = await u_ApplyDiscount(this.discount_code);
      let res_code = res.discount_codes.find(code => code.code === this.discount_code);
      this.flags.discount_error = !res_code || !res_code.applicable;
      $btn.classList.remove('is-loading');
      if (res_code && res_code.applicable) {
        this.u_RenderCart();
      }
    },

    async e_RemoveDiscount(e, code) {
      if (!code) return;
      let discount_codes = this.discount_codes;
      discount_codes = discount_codes.filter(item => item !== code);
      this.discount_codes = [...discount_codes];
      
      // Update the cart with the new discount codes
      await u_ApplyDiscount(discount_codes.join(', '));
      this.u_RenderCart();
      this.u_UpdateCartDynamicComponents(); // todo: to check, not sure why this is still needed if RenderCart is called
    },

    u_UpdateFlags() {
      this.flags.cart_empty = this.cart.item_count === 0;

      // Check if the cart contains the priority shipping product
      let shipping_product = JSON.parse(this.cache.$cart.dataset.shipping_product) || null;
      if (shipping_product) {
        this.flags.add_prio_shipping = this.cart.items.some(item => item.product_id === shipping_product.id);
      }
      else {
        this.flags.add_prio_shipping = false; // No shipping product defined
      }
    },

    u_GetDiscountCodes() {
      let discount_codes = this.cart.cart_level_discount_applications.filter(item => item.type == 'discount_code').map(item => item.title);
      this.discount_codes = discount_codes;
    },

    async u_RenderCart(line_item) {
      let cart = await u_GetCart();
      this.cart = {...cart};
      let detail = {
        cart: this.cart,
      };
      if (line_item) {
        detail.quantity = line_item.quantity ? line_item.quantity : 0;
        detail.key = line_item.key ? line_item.key : null;
      }
      else {
        detail.quantity = this.cart.item_count;
        detail.key = null;
      }
      // console.log('Cart updated:', detail);
      this.$dispatch('cart:updated', detail);
    },

    async u_UpdateCartDynamicComponents(e) {
      // console.log(e);
      this.flags.cart_rendering = true;

      let res_cart_section = await u_FetchCartSection();
      if (this.flags.cart_empty) {
        this.cache.$cart.innerHTML = res_cart_section;
        this.flags.cart_rendering = false;
        return;
      }
      else {
        let $cart_section = u_ConvertStringToHTML(res_cart_section);
        
        let $render_items = this.cache.$cart.querySelectorAll('[data-render]');
        $render_items.forEach(($item, index) => {
          let render_key = $item.dataset.render;
          let $new_item = $cart_section.querySelector(`[data-render="${render_key}"]`);
          // console.log($item, $new_item);
          if ($new_item) {
            $item.innerHTML = $new_item.innerHTML;
          } 
          else {
            console.warn(`No element found for render key: ${render_key}`);
          }

          // indicate that the component has been updated
          if (index === $render_items.length - 1) {
            setTimeout(() => {
              this.flags.cart_rendering = false;
              AOS.refreshHard();
            }, 500);
          }
        });

        // if item was removed, we need to remove the cart item from the cart
        if (e && e.detail && e.detail.quantity === 0) {
          let key = e.detail.key;
          let $item_to_remove = this.cache.$cart.querySelector(`.cart__item[data-key="${key}"]`);
          if (!$item_to_remove) return;
          $item_to_remove.remove();
        }
      }
    },

    u_FormatMoney(amount) {
      return u_FormatMoney(amount);
    },

    u_GetPrioItem() {
      let cart = this.cart;
      let shipping_product = this.shipping_product;
      if (!shipping_product) return;
      
      let item_prio_plus = cart.items.find(item => item.product_id === shipping_product.id);
      this.item_prio_plus = item_prio_plus || null;
    },

    async u_PrioShippingToggle() {
      let add_prio_shipping = this.flags.add_prio_shipping;
      let shipping_product = this.shipping_product;
      if (!shipping_product) {
        console.warn('No shipping product found for upsell.');
        return;
      }

      let shipping_item = this.cart.items.find(item => item.product_id === shipping_product.id);
      if (add_prio_shipping && shipping_item) {
        return; // Already in cart, no need to add again
      }

      if (add_prio_shipping) {
        // Add the priority shipping product to the cart
        let res = await u_AddToCart(shipping_product.variants[0].id, 1)
          .catch(err => {
            console.error('Error adding priority shipping:', err);
          });
        this.u_RenderCart({ quantity: 1, key: res.key });
      } 
      else {
        // Remove the priority shipping product from the cart
        let updates = {};
        let shipping_item = this.cart.items.find(item => item.product_id === shipping_product.id);
        updates[shipping_item.key] = 0; // Set quantity to 0 to remove
        let res = await u_UpdateCart(updates)
          .catch(err => {
            console.error('Error removing priority shipping:', err);
          });
        this.u_RenderCart({ quantity: 0, key: shipping_item.key });
      }
    }
  }));

  Alpine.data('CartShippingProgress', () => ({
    currentAmount: 0,
    threshold: 5900,
    cart: null,

    init() {
      this.InitWatchers();
      this.InitSelf();
    },

    InitSelf() {
      this.threshold = parseFloat(this.$el.dataset.threshold) || 5900; // Default to 59.00 EUR
    },

    InitWatchers() {
      document.addEventListener('store:cart:updated', () => {
        this.cart = Alpine.store('cart').cart;
        this.currentAmount = this.cart.total_price;

        this.$el.removeAttribute('x-cloak-opacity'); // Remove the hidden attribute once data is loaded
      });   
    },

    get progressPercent() {
      return Math.min((this.currentAmount / this.threshold) * 100, 100);
    },

    get remaining() {
      return Math.max(this.threshold - this.currentAmount, 0);
    },

    get isComplete() {
      return this.currentAmount >= this.threshold;
    }
  }));

  Alpine.data('CartRecommendedProducts', () => ({
    cache: {},
    swiper: null,
    init() {
      this.cache.$self = this.$el;
      this.InitSwiper();
    },
    InitSwiper() {
      let $self = this.cache.$self;
      this.swiper = new Swiper($self, {
        slidesPerView: 2.25,
        spaceBetween: 12,
        pagination: {
          el: $self.querySelector('.swiper-pagination'),
          clickable: true,
          draggable: true
        },        
        breakpoints: {
          640: {
            slidesPerView: 6.25,
            slidesPerGroup: 3,
            spaceBetween: 24,
          }
        }
      });
    }
  }));
});